import 'bootstrap/dist/css/bootstrap.min.css';
// import Header from '../header';
import Footer from '../footer';
import "animate.css/animate.min.css";
import '../../sass/_mobile.scss';

const Layout = (props) => {
    return (
        <div>
            {/* <Header /> */}
            {props.children}
            <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/6826765.js"></script>
            <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/6826765.js"></script>            
            <Footer />
        </div>
    )
}
export default Layout;